import React, { Component } from 'react';
import {
    ReActivateCourseJazzCash, fetchJazzCashAddiotionalData, applyCheckoutCoupon, paymentCashOnDelivery
} from "../../../actions/feedActions";
import $ from 'jquery';
import Snackbar from '../../Snackbar';

class CheckOutComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selecteCourseTab: 1,
            couponCode: '',
            couponid: 0,
            isCouponApplied: false,
            isCouponError: '',
            couponDiscountAmount: '',
            couponDiscountedPrice: '',
            sendingPrice: '',
            snackbarMessage: 'Enrolled Successfully',
            paymentMethodType: 0, // this state is specific to payment type 0 which is jazzcash

            // these states are specifically for jazcash form submission
            form_amount: '',
            form_discountedAmount: '',
            form_couponid: '',
            form_txnDateTime: '',
            form_txnExpiryDateTime: '',
            form_orderRefNum: '',
            form_securehashMobile: '',
            form_securehashCard: '',
            form_billReference: '',
            form_userid: '',
            form_userid_numeric: '',
            form_course_name: '',
            form_courseid: '',
            form_program_id: '',
            form_whichForm: '',

            form_MerchantID: '', //Your Merchant from transaction Credentials
            form_Password: '',   //Your Password from transaction Credentials
            form_ReturnURL: '',  //Your Return URL
            form_HashKey: '', //Your HashKey integrity salt from transaction Credentials	
            form_PostURL: '',
            form_Language: '',
            form_TxnCurrency: '',
            form_Version: '',
            isFreeClass: false,
        };
    }

    proceedCheckoutFunction = () => {
        const { courseId, studentId, courseDetails, programId } = this.props;
        if (document.getElementById('card_payment').checked || document.getElementById('mobile_account').checked) {
            ReActivateCourseJazzCash(courseId, studentId, programId, this.state.isCouponApplied ? Math.ceil(this.state.couponDiscountedPrice) : courseDetails.course_price, courseDetails.course_name, 0, this.state.couponid)
                .then((res) => {
                    console.log("JazzCash API Response", res);
                    if (res.data.status == "success") {
                        this.setState({
                            form_amount: res.data.result.Amount,
                            form_discountedAmount: res.data.result.DiscountedAmount,
                            form_couponid: res.data.result.couponid,
                            form_txnDateTime: res.data.result.txndatetime,
                            form_txnExpiryDateTime: res.data.result.txnexpirydatetime,
                            form_orderRefNum: res.data.result.txnrefnumber,
                            form_securehashMobile: res.data.result.securehashMobile,
                            form_securehashCard: res.data.result.securehashCard,
                            form_billReference: res.data.result.BillReference,
                            form_userid: studentId,
                            form_course_name: courseDetails.course_name,
                            form_courseid: courseId,
                            form_program_id: programId,
                            form_whichForm: this.state.paymentMethodType == 1 ? 'mobile' : 'card'
                        }, () => {

                            console.log('form_amount', this.state.form_amount);
                            console.log('form_discountedAmount', this.state.form_discountedAmount);
                            console.log('form_couponid', this.state.form_couponid);
                            console.log('form_txnDateTime', this.state.form_txnDateTime);
                            console.log('form_txnExpiryDateTime', this.state.form_txnExpiryDateTime);
                            console.log('form_orderRefNum', this.state.form_orderRefNum);
                            console.log('form_securehashMobile', this.state.form_securehashMobile);
                            console.log('form_securehashCard', this.state.form_securehashCard);
                            console.log('form_billReference', this.state.form_billReference);
                            console.log('form_userid', this.state.form_userid);
                            console.log('form_course_name', this.state.form_course_name);
                            console.log('form_courseid', this.state.form_courseid);
                            console.log('form_program_id', this.state.form_program_id);
                            console.log('form_whichForm', this.state.form_whichForm);

                            // calls an action for Jazz Cash Method extra details
                            fetchJazzCashAddiotionalData(this.state.form_userid)
                                .then((res2) => {
                                    console.log("After API Response", res2);
                                    var addOndata = res2.data.result;
                                    addOndata = JSON.parse(atob(addOndata));

                                    this.setState({
                                        form_MerchantID: addOndata.MerchantID, //Your Merchant from transaction Credentials
                                        form_Password: addOndata.Password,   //Your Password from transaction Credentials
                                        form_ReturnURL: addOndata.ReturnURL,  //Your Return URL
                                        form_HashKey: addOndata.HashKey, //Your HashKey integrity salt from transaction Credentials	
                                        form_PostURL: addOndata.PostURL,
                                        form_Language: addOndata.Language,
                                        form_TxnCurrency: addOndata.TxnCurrency,
                                        form_Version: addOndata.Version,
                                        form_userid_numeric: addOndata.user_id
                                    }, () => {

                                        console.log('form_MerchantID', this.state.form_MerchantID);
                                        console.log('form_Password', this.state.form_Password);
                                        console.log('form_ReturnURL', this.state.form_ReturnURL);
                                        console.log('form_HashKey', this.state.form_HashKey);
                                        console.log('form_PostURL', this.state.form_PostURL);
                                        console.log('form_Language', this.state.form_Language);
                                        console.log('form_TxnCurrency', this.state.form_TxnCurrency);
                                        console.log('form_Version', this.state.form_Version);
                                        console.log('form_userid_numeric', this.state.form_userid_numeric);

                                        var dynFormId = this.state.form_whichForm + 'Form';
                                        console.log(dynFormId);
                                        // form submission
                                        document.getElementById(dynFormId).submit();

                                        //Pixel Event
                                        // window.fbq('track', 'Purchase', { value: 0.00, currency: 'PKR' });
                                    })
                                    debugger;
                                })
                                .catch((err2) => {
                                    debugger;
                                })

                        })
                    }
                })
                .catch((err) => {
                    debugger;
                })
        }
    }

    amountZeroProceed = () => {
        paymentCashOnDelivery(
            this.props.studentId,
            this.props.feedbackData[0]['course_id'],
            this.state.couponCode,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ).then((res) => {
            debugger;
            $('#changeCourseModal').modal('hide');
            this.snackBarFunction();
            setTimeout(() => {
                window.location.reload();
            }, 3000);
        })
            .catch((err) => {
                debugger;
            })

    }

    applyCouponCode = () => {
        const { courseDetails } = this.props;
        var selectedDayId = 0;
        applyCheckoutCoupon(
            courseDetails.id, // course id
            this.state.couponCode, // coupon code applied
            selectedDayId // course selected days id
        ) //calling action for applying checkout coupon
            .then((res) => {
                if (res.data.result.couponid != 0) {
                    debugger;
                    this.setState({
                        couponid: res.data.result.couponid,
                        isCouponApplied: true,
                        isCouponError: '',
                        couponDiscountAmount: res.data.result.discount,
                        couponDiscountedPrice: res.data.result.discountPrice,
                        // isFreeClass: false
                    })
                }
                else {
                    debugger;
                    this.setState({
                        couponid: 0,
                        isCouponApplied: false,
                        isCouponError: '*This coupon is not valid or applicable.',
                        couponDiscountAmount: 0,
                        couponDiscountedPrice: '',
                        // isFreeClass: false
                    })
                }
            })
            .catch((err) => {

            })
    }
    snackBarFunction = () => {
        var x = document.getElementById("snackbar");
        x.className = "show";
        setTimeout(function () {
            x.className = x.className.replace("show", "");
        }, 3000);
    };
    render() {
        const { selecteCourseTab, form_Language, form_MerchantID, form_Password, form_PostURL, form_ReturnURL, form_TxnCurrency, form_Version, form_amount, form_billReference, form_couponid, form_course_name, form_courseid, form_discountedAmount, form_orderRefNum, form_program_id, form_securehashCard, form_securehashMobile, form_txnDateTime, form_txnExpiryDateTime, form_userid, form_userid_numeric, form_whichForm, isCouponEnabled, prevCardInfo, allCards, isCouponApplied } = this.state;
        return <div>
            <Snackbar msg={this.state.snackbarMessage} color="#01ac8a" />
            <div className="row">
                <div className="col-10">
                    <div class="form-group">
                        <label for="exampleInputEmail1" style={{ color: '#36a420' }}>Do you have a Promo Code?</label>
                        <input type="text" style={{ border: '1px solid #36a420' }} className="form-control form-control-sm" value={this.state.couponCode} onChange={(e) => this.setState({ couponCode: e.target.value })} placeholder="Enter promo code here" />
                        {this.state.isCouponError != '' ?
                            <small id="emailHelp" className="form-text text-danger font-weight-bold">{this.state.isCouponError}</small>
                            : null
                        }
                    </div>
                </div>
                <div className="col-2">
                    <button className='btn btn-success btn-sm' style={{ position: "absolute", left: 0, marginTop: 27 }} onClick={this.applyCouponCode}>Apply</button>
                </div>

                <div className="col-6">
                    <label>Price:</label>
                </div>
                <div className="col-6">
                    <label className="font-weight-bold">PKR {this.props.courseDetails.course_price}</label>
                </div>
                {this.state.isCouponApplied ?
                    <React.Fragment>
                        <div className="col-6">
                            <label>Promo discount:</label>
                        </div>
                        <div className="col-6">
                            <label className="font-weight-bold">PKR -{Math.trunc(this.state.couponDiscountAmount)}</label>
                        </div>
                    </React.Fragment>
                    :
                    null}
                <div className="col-md-12">
                    <hr />
                    {this.state.isCouponApplied ?
                        <div className="row">
                            <div className="col-6">
                                <label>Total price:</label>
                            </div>
                            <div className="col-6">
                                <label className="font-weight-bold" style={{ fontSize: '20px' }}>PKR {Math.ceil(this.state.couponDiscountedPrice)}</label>
                            </div>
                        </div>
                        :
                        null}
                </div>

                {this.state.couponDiscountedPrice === 0 ?

                    <div className="col-md-12">
                        <button className="btn btn-success btn-block mt-2 mb-2" onClick={this.amountZeroProceed}>Enroll</button>
                    </div>

                    :
                    <React.Fragment>
                        <div className="col-md-12 text-center">
                            <button className={selecteCourseTab === 1 ? "changeKGSBtnActive" : "changeKGSBtn"} onClick={() => this.setState({ selecteCourseTab: 1 })}>Bank Transfer</button>

                            <button className={selecteCourseTab !== 1 ? "allCourseBtnActive" : "allCourseBtn"} onClick={() => this.setState({ selecteCourseTab: 2 })}>Pay Online</button>
                        </div>

                        {/* Card Payment */}
                        <form method="post" action={"" + form_PostURL} id="cardForm">
                            <input type="hidden" name="pp_Version" value={"" + form_Version} />
                            <input type="hidden" name="pp_TxnType" value="MIGS" />
                            <input type="hidden" name="pp_Language" value={"" + form_Language} />
                            <input type="hidden" name="pp_MerchantID" value={"" + form_MerchantID} />
                            <input type="hidden" name="pp_SubMerchantID" value="" />
                            <input type="hidden" name="pp_Password" value={"" + form_Password} />
                            <input type="hidden" name="pp_TxnRefNo" value={"" + form_orderRefNum} />
                            <input type="hidden" name="pp_Amount" value={"" + form_amount} />
                            <input type="hidden" name="pp_TxnCurrency" value={"" + form_TxnCurrency} />
                            <input type="hidden" name="pp_TxnDateTime" value={"" + form_txnDateTime} />
                            <input type="hidden" name="pp_BillReference" value={"" + form_billReference} />
                            <input type="hidden" name="pp_Description" value={"" + form_course_name} />
                            <input type="hidden" name="pp_DiscountedAmount" value={"" + form_discountedAmount} />
                            <input type="hidden" name="pp_DiscountBank" value="" />
                            <input type="hidden" name="pp_TxnExpiryDateTime" value={"" + form_txnExpiryDateTime} />
                            <input type="hidden" name="pp_ReturnURL" value={"" + form_ReturnURL} />
                            <input type="hidden" name="pp_SecureHash" id="securehashCard" value={"" + form_securehashCard} />
                            <input type="hidden" name="ppmpf_1" value={"" + form_userid_numeric} />
                            <input type="hidden" name="ppmpf_2" value={"" + form_courseid} />
                            <input type="hidden" name="ppmpf_3" value={"" + form_program_id} />
                            <input type="hidden" name="ppmpf_4" value={"" + form_couponid} />
                            <input type="hidden" name="ppmpf_5" value="" />
                        </form>
                        {/* End Card Payment */}

                        {/* Mobile Payment */}
                        <form method="post" action={"" + form_PostURL} id="mobileForm">
                            <input type="hidden" name="pp_Version" value={"" + form_Version} />
                            <input type="hidden" name="pp_TxnType" value="MWALLET" />
                            <input type="hidden" name="pp_Language" value={"" + form_Language} />
                            <input type="hidden" name="pp_MerchantID" value={"" + form_MerchantID} />
                            <input type="hidden" name="pp_SubMerchantID" value="" />
                            <input type="hidden" name="pp_Password" value={"" + form_Password} />
                            <input type="hidden" name="pp_TxnRefNo" value={"" + form_orderRefNum} />
                            <input type="hidden" name="pp_Amount" value={"" + form_amount} />
                            <input type="hidden" name="pp_TxnCurrency" value={"" + form_TxnCurrency} />
                            <input type="hidden" name="pp_TxnDateTime" value={"" + form_txnDateTime} />
                            <input type="hidden" name="pp_BillReference" value={"" + form_billReference} />
                            <input type="hidden" name="pp_Description" value={"" + form_course_name} />
                            <input type="hidden" name="pp_DiscountedAmount" value={"" + form_discountedAmount} />
                            <input type="hidden" name="pp_DiscountBank" value="" />
                            <input type="hidden" name="pp_TxnExpiryDateTime" value={"" + form_txnExpiryDateTime} />
                            <input type="hidden" name="pp_ReturnURL" value={"" + form_ReturnURL} />
                            <input type="hidden" name="pp_SecureHash" id="securehashMobile" value={"" + form_securehashMobile} />
                            <input type="hidden" name="ppmpf_1" value={"" + form_userid_numeric} />
                            <input type="hidden" name="ppmpf_2" value={"" + form_courseid} />
                            <input type="hidden" name="ppmpf_3" value={"" + form_program_id} />
                            <input type="hidden" name="ppmpf_4" value={"" + form_couponid} />
                            <input type="hidden" name="ppmpf_5" value="" />
                        </form>
                        {/* End Mobile Payment */}

                        {selecteCourseTab === 1 ?
                            <React.Fragment>

                                <div className="col-md-12 mt-4">
                                    <div class="form-group">
                                        <label className="font-weight-bold" style={{ fontSize: 14 }}>Here are our account details for bank transfer:</label>
                                        <p style={{ marginTop: '10px' }}>
                                            <ul>
                                                <li><strong>Account Title:</strong>
                                                    <br />Lincoln Method </li>
                                                <li><strong>Account Number:</strong><br /> 0162-1007 0865 72</li>
                                                <li><strong>Account Type:</strong> <br />Current Account</li>
                                                <li><strong>Bank name:</strong> <br />Bank Alfalah</li>
                                                <li><strong>IBAN Number:</strong> <br />PK70 ALFH 0162 0010 0708 6572</li>
                                            </ul>
                                        </p>
                                        <p style={{ color: "#182B49" }}>Please make sure to WhatsApp your deposit receipt at our official number <a style={{ fontWeight: 'bold' }} href="callto:03008296228">+923008296228</a> to proceed further.</p>
                                    </div>
                                </div>


                            </React.Fragment>
                            :
                            <React.Fragment>
                                <div className="col-md-12 mt-4">
                                    <div class="form-group">
                                        <label className="font-weight-bold" style={{ fontSize: 14 }}>Select Payment Type</label>
                                    </div>
                                    <div style={{ margin: '20px' }}>
                                        <div class="form-check mb-2">
                                            <input type="radio" checked={this.state.paymentMethodType == 0} className="form-check-input" checked={this.state.paymentMethodType == 0} type="radio" id="card_payment" name="card_payment" onChange={(evt) => {
                                                this.setState({ paymentMethodType: 0 })
                                            }} />
                                            <label className="form-check-label" for="exampleCheck1">Debit/Credit Card</label>
                                        </div>
                                        <div class="form-check">
                                            <input type="radio" checked={this.state.paymentMethodType == 1} className="form-check-input" checked={this.state.paymentMethodType == 1} type="radio" id="mobile_account" name="mobile_account" onChange={(evt) => {
                                                this.setState({ paymentMethodType: 1 })
                                            }} />
                                            <label className="form-check-label" for="exampleCheck1">Jazz Cash mobile account</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 text-center mt-4">
                                    <button className="btn btn-success btn-block" onClick={this.proceedCheckoutFunction}>Next</button>
                                </div>
                            </React.Fragment>
                        }
                    </React.Fragment>
                }


            </div>
        </div>;
    }
}

export default CheckOutComponent;